<template>
    <ui-modal ref="modal" :width="496" height="auto" spacing="56px 20px" class="modal">
        <div class="color-1 font-bold title">{{ $t("Notification") }}</div>
        <div class="text">{{ message }}</div>
    </ui-modal>
</template>
<script lang="tsx" setup>
//* 组件库
import { UiModal } from "various-ui";
const message = ref<string>("");
const modal = ref<InstanceType<typeof UiModal>>();
const open = (msg: string) => {
    message.value = msg;
    modal.value?.openModal();
};
defineExpose({ open });
</script>

<style lang="less" scoped>
.modal {
    :deep(.ui-modal-header) {
        margin-bottom: 0;
    }
    .title {
        margin-bottom: 12px;
        font-size: 24px;
        text-align: center;
    }
    .text {
        font-size: 16px;
        text-align: center;
    }
}
</style>
